// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"54747fc7","473":"a9f38a14","492":"af185366","586":"a631a9e5","811":"660ff678","852":"162d4f8f"}[chunkId] + ".chunk.css";
};